import {useSignals} from '@preact/signals-react/runtime'
import moment from 'moment'
import {Divider} from 'primereact/divider'
import {ReactComponent as PenIcon} from '../../assets/icons/PenIcon.svg'
import {ReactComponent as TagIcon} from '../../assets/icons/TagIcon.svg'
import {ReactComponent as WaterIcon} from '../../assets/icons/WaterIcon.svg'
import {useAppConfig} from '../../context/app/AppContext'
import {convertKeyToLabel} from '../table-utils/TableUtils'
import {reminderKeys, reminderTypes} from './ReminderConstants'
const CalendarFormSummary = ({
    data,
    patientName = '',
    ownerName,
    recipientSelectedList = [],
}) => {
    useSignals()
    const {timezoneId} = useAppConfig()
    const frequency = () => {
        let value = null
        let holderList = []
        if (data[reminderKeys.frequency]) {
            holderList = [...data[reminderKeys.frequency]]
        }
        if (data[reminderKeys.otherFrequency]) {
            holderList.push(data[reminderKeys.otherFrequency])
        }

        if (holderList.length > 0) {
            value = holderList.join(', ')
        }
        return value
    }
    const instructions = () => {
        let value = null
        let holderList = []
        if (data[reminderKeys.instructions]) {
            holderList = [...data[reminderKeys.instructions]]
        }
        if (data[reminderKeys.otherInstructions]) {
            holderList.push(data[reminderKeys.otherInstructions])
        }

        if (holderList.length > 0) {
            value = holderList.join(', ')
        }
        return value
    }

    const convertDateTimeToTz = (dateTime, format, hideTz = false) => {
        const pattern = format ? format : 'MMMM Do YYYY HH:mm a'
        const dataTime = dateTime ? moment(dateTime) : moment()
        const userTz = Intl.DateTimeFormat().resolvedOptions().timeZone
        return {
            userTz: ` ${dataTime.format(`${pattern}`)}${
                !hideTz
                    ? ` (${userTz} GMT ${dataTime.tz(userTz).format('Z')})`
                    : ''
            }`,
            clientTz: ` ${dataTime.tz(timezoneId).format(`${pattern}`)}${
                !hideTz
                    ? ` (${timezoneId} GMT ${dataTime
                          .tz(timezoneId)
                          .format('Z')})`
                    : ''
            }`,
        }
    }
    const userType = {
        user: 'user',
        generalPractitioner: 'generalPractitioner',
        nextOfKin: 'nextOfKin',
    }
    return (
        <div
            style={{
                maxHeight: '300px',
                overflowY: 'auto',
            }}>
            <h5>
                You are creating a{' '}
                <span className="text-blue-500 font-bold">
                    {convertKeyToLabel(data[reminderKeys.type])}
                </span>{' '}
                for the patient{' '}
                {patientName && (
                    <span className="text-blue-500 font-bold">
                        ({patientName})
                    </span>
                )}
            </h5>
            {data[reminderKeys.type] === reminderTypes.reminder && (
                <div className="flex flex-column gap-3 px-1  text-lg mb-3">
                    {data[reminderKeys.description] && (
                        <div className="flex gap-2">
                            <div className=" flex gap-2 font-semibold text-darkcyan">
                                {' '}
                                <PenIcon className="mt-1" /> Description:
                            </div>
                            <div> {data[reminderKeys.description]}</div>
                        </div>
                    )}
                    {frequency() && (
                        <div className="flex gap-2">
                            <div className="flex gap-2 font-semibold text-darkcyan">
                                <WaterIcon className="mt-1" /> Frequency:{' '}
                            </div>{' '}
                            <div> {frequency()}</div>
                        </div>
                    )}
                    {instructions() && (
                        <div className="flex gap-2">
                            <div className="flex gap-2 font-semibold text-darkcyan">
                                <TagIcon className="mt-1" /> Instructions:{' '}
                            </div>{' '}
                            <div> {instructions()}</div>
                        </div>
                    )}
                </div>
            )}
            {data[reminderKeys.type] === reminderTypes.appointment && (
                <div className="flex flex-column gap-3 px-1  text-lg mb-3">
                    {data[reminderKeys.appointmentType] && (
                        <div className="flex gap-2">
                            <div className="flex gap-2 font-semibold text-darkcyan">
                                {' '}
                                <PenIcon className="mt-1" /> Appointment Type:
                            </div>
                            <div> {data[reminderKeys.appointmentType]}</div>
                        </div>
                    )}
                    {data[reminderKeys.description] && (
                        <div className="flex gap-2">
                            <div className="flex gap-2 font-semibold text-darkcyan">
                                {' '}
                                <PenIcon className="mt-1" /> Description:
                            </div>
                            <div> {data[reminderKeys.description]}</div>
                        </div>
                    )}

                    {recipientSelectedList.length > 0 && (
                        <div className="">
                            <div className="flex gap-2 font-semibold text-darkcyan">
                                <WaterIcon className="mt-1" /> The appointment
                                will be sent to:{' '}
                            </div>{' '}
                            <div className="px-4">
                                {recipientSelectedList.map((item, idx) => (
                                    <div
                                        key={idx}
                                        className="text-lg font-semibold"
                                        style={{
                                            color:
                                                {
                                                    [userType.user]: 'darkcyan',
                                                    [userType.generalPractitioner]:
                                                        'var(--blue-500)',
                                                    [userType.nextOfKin]:
                                                        'var(--purple-500)',
                                                }[item.userType] || '',
                                        }}>
                                        {idx + 1}
                                        {'. '}
                                        {item.label}
                                        {/* {item.userType ===
                                                                        'user'
                                                                            ? 'Current Patient'
                                                                            : item.userType} */}
                                        {item.method.length > 0 && (
                                            <span className="text-700">
                                                : {item.method.join(', ')}
                                            </span>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            )}

            {data[reminderKeys.description] && (
                <div className=" text-lg font-semibold">
                    {data[reminderKeys.type] === reminderTypes.reminder &&
                    !data[reminderKeys.oneTime] ? (
                        <p>
                            The reminder will be sent from{' '}
                            <span className="font-bold text-blue-500">
                                {
                                    convertDateTimeToTz(
                                        data[reminderKeys.startDate],
                                        'MMMM Do YYYY',
                                        true,
                                    ).userTz
                                }{' '}
                            </span>
                            to{' '}
                            <span className="font-bold text-blue-500">
                                {' '}
                                {
                                    convertDateTimeToTz(
                                        data[reminderKeys.endDate],
                                        'MMMM Do YYYY',
                                        true,
                                    ).userTz
                                }{' '}
                            </span>
                            at{' '}
                            <span className="font-bold text-blue-500">
                                {' '}
                                {
                                    convertDateTimeToTz(
                                        data[reminderKeys.endDate],
                                        'HH:mm a',
                                    ).userTz
                                }{' '}
                            </span>{' '}
                            in your current time zone via Push Notification.
                            This time will be reconfigured to match the client’s
                            time zone, which is from{' '}
                            <span className="font-bold text-blue-500">
                                {
                                    convertDateTimeToTz(
                                        data[reminderKeys.startDate],
                                        'MMMM Do YYYY',
                                        true,
                                    ).clientTz
                                }{' '}
                            </span>
                            to{' '}
                            <span className="font-bold text-blue-500">
                                {' '}
                                {
                                    convertDateTimeToTz(
                                        data[reminderKeys.endDate],
                                        'MMMM Do YYYY',
                                        true,
                                    ).clientTz
                                }{' '}
                            </span>
                            at{' '}
                            <span className="font-bold text-blue-500">
                                {' '}
                                {
                                    convertDateTimeToTz(
                                        data[reminderKeys.endDate],
                                        'HH:mm a',
                                    ).clientTz
                                }{' '}
                            </span>{' '}
                        </p>
                    ) : (
                        <p>
                            The patient will be reminded at{' '}
                            <span className="font-bold text-blue-500">
                                {
                                    convertDateTimeToTz(
                                        data[reminderKeys.dateTime],
                                    ).userTz
                                }
                            </span>{' '}
                            in your current time zone via Push Notification.
                            This time will be reconfigured to match the client’s
                            time zone, which is also at
                            <span className="font-bold text-blue-500">
                                {
                                    convertDateTimeToTz(
                                        data[reminderKeys.dateTime],
                                    ).clientTz
                                }
                            </span>
                        </p>
                    )}
                </div>
            )}
            <Divider />
        </div>
    )
}

export default CalendarFormSummary
